// extracted by mini-css-extract-plugin
export var orderSearchResultCard = "_o-0";
export var skeletonCard = "_o-1";